import {ChangeEvent, FC} from 'react';
import {
  ServiceRequestStatusesByDate,
  ServiceRequestStatusesByDateColors,
} from '../../constants/service-requests-statuses-by-date';
import {Checkbox, FormControl, FormControlLabel, FormGroup} from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import {useStoresContext} from '../../hooks/useStoresContext';
import {useStore} from 'zustand';

type Option = {
  value: ServiceRequestStatusesByDate;
  label: string;
};

export const statusOptions: Option[] = [
  {
    value: ServiceRequestStatusesByDate.COMPLETED_ON_TIME,
    label: '',
  },
  {
    value: ServiceRequestStatusesByDate.COMPLETED_NOT_CLOSED,
    label: '',
  },
  {
    value: ServiceRequestStatusesByDate.IN_PROGRESS,
    label: '',
  },
  {
    value: ServiceRequestStatusesByDate.DEADLINE_SOON,
    label: '',
  },
  {
    value: ServiceRequestStatusesByDate.DEADLINE_OVERDUE,
    label: '',
  },
];

interface Props {
  serviceType: string;
}

export const DashboardServiceRequestStatusFilters: FC<Props> = ({serviceType}) => {
  const {serviceRequestsStatusFilterStore} = useStoresContext(serviceType);
  const {statusFilter, setStatusFilter} = useStore(serviceRequestsStatusFilterStore);

  const handleChange = (changedValue: ServiceRequestStatusesByDate) => (_: ChangeEvent<HTMLInputElement>) => {
    const nextValue = statusFilter.includes(changedValue)
      ? statusFilter.filter((v) => v !== changedValue)
      : [...statusFilter, changedValue];

    setStatusFilter(nextValue);
  };

  return (
    <FormControl>
      <FormGroup row>
        {statusOptions.map(({value: v, label}) => {
          const statusColor = ServiceRequestStatusesByDateColors[v];

          return (
            <FormControlLabel
              key={v}
              control={
                <Checkbox
                  icon={<RadioButtonUncheckedIcon sx={{color: statusColor}} />}
                  checkedIcon={<RadioButtonCheckedIcon sx={{color: statusColor}} />}
                  sx={{
                    color: statusColor,
                    '&.Mui-checked': {
                      color: statusColor,
                    },
                  }}
                  checked={statusFilter.includes(v)}
                  onChange={handleChange(v)}
                  inputProps={{'aria-label': label}}
                />
              }
              label={label}
            />
          );
        })}
      </FormGroup>
    </FormControl>
  );
};
